import type { Choices } from "@busbud/int-schemas/lib";

import type { NonEmptyVehicleLayoutCell } from "@app/types/napi-layout-types";

export class SeatSelectionNoRules {
  public validateRules(): boolean {
    return true;
  }

  public getInvalidGender(): Choices.Gender | null {
    return null;
  }

  public getMaxGenderRule(): number {
    throw new Error("No rules");
  }

  public getGenderedSeatBeforeSelection(
    gender: Choices.Gender
  ): NonEmptyVehicleLayoutCell["id"][] {
    throw new Error(`No gendered seats for ${gender} gender.`);
  }
}
